import styled from 'styled-components'

import { MobileInput } from '../styles'

export const LoginMobileInput = styled(MobileInput)`
    /* margin-top: 10px; */
`
